import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ResponseModel } from "src/app/models/response.model";
import { BaseService } from "src/app/services/base.service";
import { CadastroModel } from "../models/cadastro.model";
import { UserInfoModel } from "../models/user-info.model";

@Injectable()
export class ContaService extends BaseService {

    obterContas(): Observable<any> {
        var contas = this.get('contas/');
        return contas;

    }
    cadastrar(data: CadastroModel) {
        let url: string='contas';
        if (data.perfil === 'Administrador')
            url += '/cadastrar-administrador/'
        else
            url += '/cadastrar-editor'
        var cadastro = this.post(url, data);
        return cadastro;
    }

    redefinirSenha(data: CadastroModel) {
        let url: string='contas';
            url += '/redefinir-senha'
        var cadastro = this.put(url, data);
        return cadastro;
    }
}